
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
    isParticipantModerator
} from '../../base/participants';
import { approveKnockingParticipant, rejectKnockingParticipant } from '../../lobby/actions';
import { showNotification } from '../../notifications';
import { ACTION_TRIGGER, MEDIA_STATE } from '../constants';

import { ParticipantItem } from './ParticipantItem';

type Props = {

    /**
     * Participant reference.
     */
    participant: Object
};

export const LobbyParticipantItem = ({ participant }: Props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const totalParticipants = useSelector(state => (state['features/base/participants'] || []).length);

    const participantAllowedInMeeting = useSelector(
        state => state['features/base/jwt']?.meetingDetails?.max_participants
    );

    const maxParticipants = typeof participantAllowedInMeeting === 'number'
        ? participantAllowedInMeeting
        : participantAllowedInMeeting ? Number(participantAllowedInMeeting) : Infinity;

    const availableSlots = Math.max(0, maxParticipants - totalParticipants);

    const admit = useCallback(() => {
        if (availableSlots > 0) {
            dispatch(approveKnockingParticipant(participant.id));
        } else {
            dispatch(showNotification({
                descriptionArguments: { number: maxParticipants },
                descriptionKey: 'notify.participantLimitReachedDes',
                titleKey: 'notify.participantLimitReached',
                customActionNameKey: 'notify.upgradeNow',
                customActionHandler: () => window.open('/products/video-conference/pricing', '_blank')
            }));
        }
    }, [ dispatch, participant.id, availableSlots, maxParticipants ]);

    const reject = useCallback(() => {
        dispatch(rejectKnockingParticipant(participant.id));
    }, [ dispatch, participant.id ]);

    const style = {
        width: '10px'
    };

    return (
        <ParticipantItem
            actionsTrigger = { ACTION_TRIGGER.PERMANENT }
            audioMediaState = { MEDIA_STATE.NONE }
            hideOptions = { true }
            isModerator = { isParticipantModerator(participant) }
            name = { participant.name }
            participant = { participant }
            videoMuteState = { MEDIA_STATE.NONE }>
            <button
                className = 'participant-action-button-primary'
                onClick = { admit }>
                {t('lobby.admit')}
            </button>
            <div style = { style } />
            <button
                className = 'participant-action-button-secondary'
                onClick = { reject }>
                {t('lobby.reject')}
            </button>

        </ParticipantItem>
    );
};
